import './Dummy.less';

import React, { FC } from 'react';
import clsx from 'clsx';

const Dummy: FC<{ otherClass?: string; children?: any }> = ({ otherClass, children }) => (
    <div className={clsx('dummy', otherClass)}>{children}</div>
);

export default Dummy;
